import { Component, Input } from '@angular/core';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { TRANSLATION_TITLE_MODAL_CASE_TYPE } from '@wdx/shared/utils';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'organism-create-case-modal',
    templateUrl: './organism-create-case-modal.component.html',
    standalone: false,
})
export class OrganismCreateCaseModalComponent {
    @Input() opportunityId: string;
    @Input() partyId: string;
    @Input() entityType: SystemEntity;
    @Input() entityId: string;
    @Input() otherFormInitIds?: Record<string, string>;

    readonly TRANSLATION_TITLE_MODAL_CASE_TYPE =
        TRANSLATION_TITLE_MODAL_CASE_TYPE;
}
